import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Drawer/drawer';
import { css } from '@patternfly/react-styles';
export var DrawerColorVariant;

(function (DrawerColorVariant) {
  DrawerColorVariant["default"] = "default";
  DrawerColorVariant["light200"] = "light-200";
})(DrawerColorVariant || (DrawerColorVariant = {}));

export var DrawerContext = React.createContext({
  isExpanded: false,
  isStatic: false,
  onExpand: function onExpand() {},
  position: 'right',
  drawerRef: null
});
export var Drawer = function Drawer(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      _a$isExpanded = _a.isExpanded,
      isExpanded = _a$isExpanded === void 0 ? false : _a$isExpanded,
      _a$isInline = _a.isInline,
      isInline = _a$isInline === void 0 ? false : _a$isInline,
      _a$isStatic = _a.isStatic,
      isStatic = _a$isStatic === void 0 ? false : _a$isStatic,
      _a$position = _a.position,
      position = _a$position === void 0 ? 'right' : _a$position,
      _a$onExpand = _a.onExpand,
      onExpand = _a$onExpand === void 0 ? function () {} : _a$onExpand,
      props = __rest(_a, ["className", "children", "isExpanded", "isInline", "isStatic", "position", "onExpand"]);

  var drawerRef = React.useRef();
  return React.createElement(DrawerContext.Provider, {
    value: {
      isExpanded: isExpanded,
      isStatic: isStatic,
      onExpand: onExpand,
      position: position,
      drawerRef: drawerRef
    }
  }, React.createElement("div", Object.assign({
    className: css(styles.drawer, isExpanded && styles.modifiers.expanded, isInline && styles.modifiers.inline, isStatic && styles.modifiers.static, position === 'left' && styles.modifiers.panelLeft, position === 'bottom' && styles.modifiers.panelBottom, className),
    ref: drawerRef
  }, props), children));
};
Drawer.displayName = 'Drawer';